import DiagramUtils from "../utils/DiagramUtils";

export default class PluginDragMove {


    constructor(designer, {
    } = {}) {

        this.designer = designer;
    }

    install() {

    }

    uninstall() {

    }

    onDragMove(e) {

        if (!this.dragStartPoint)
            return;

        const x = e.screenX;
        const y = e.screenY;
        const dx = x - this.dragStartPoint.x;
        const dy = y - this.dragStartPoint.y;

        const res = this.designer.resolution;
        const mx = dx * res;
        const my = dy * res;

        const items = this.designer.selectedItems;
        items.forEach(c => {
            const parentScale = c._sys.parent ? c._sys.parent.getViewScale() : 1;
            c.x = Math.round(this.modelRectBackup[c.id].x + mx / parentScale);
            c.y = Math.round(this.modelRectBackup[c.id].y + my / parentScale);
        });
    }

    onDragMoveStart(e) {

        this.designer.properties.isDiagramDragging = true;
        this.dragStartPoint = {
            x: e.screenX,
            y: e.screenY
        }

        this.modelRectBackup = {}
        const items = this.designer.selectedItems;
        items.forEach(c => {
            this.modelRectBackup[c.id] = {
                x: c.x,
                y: c.y,
            }
        });
    }

    onDragMoveStop(e) {

        this.designer.properties.isDiagramDragging = false;
        this.dragStartPoint = null;
        this.modelRectBackup = null;
    }
}